import axios from 'axios';
import {ref, reactive, computed, toRefs} from 'vue';
import {appendAccessToken} from  "@/modules/utils/pathUtils";

const bookData = reactive({
    annotations:[],
    catalog:[],
    config:{},
    pagenames:[],
    resources:{},
    tools:[]
});


export function useDataLoader() {

    //TODO: error handling further...
    const fetchAll = async (path) => {

        try {
            let result = await Promise.all([
                await fetchAnnotations(`${path}/page-image/`),
                await fetchCatalog(path),
                await fetchConfig(path),
                await fetchPageNames(path),
                await fetchResources(path),
                await fetchTools(path),
            ]);

            //TODO: clean codes...
            bookData.annotations = result[0];
            bookData.catalog = result[1];
            bookData.config = result[2];
            bookData.pagenames = result[3];
            bookData.resources = result[4];
            bookData.tools = result[5];
            return result;
        } catch (e) {
            console.log("@fetchAll catch error")
            throw new Error("info_msg_book_coming")
        }
    }

    const fetchAnnotations = async (path) => {
        let res = await axios.get(appendAccessToken(`${path}/annotations.json`));
        return res.data;
    }

    /**
     * Notice that some browsers (e.g Chrome) sort Object automatically. This isn ot expected as it breaks the raw data order.
     * The raw data page name order can be retained by converting to array.
     * @param path
     * @returns {Promise<void>}
     */
    const fetchPageNames = async (path) => {
        let res = await axios.get(appendAccessToken(`${path}/pagenames.json`));
        let pageData;
        let responseText = res.request.responseText;
        responseText = responseText.replace('{','');
        responseText = responseText.replace('}','');
        pageData = responseText.split(',');

        return pageData.map(el=>{
            el = el.replace('":"', ",");
            el = el.replace('"', "");
            return el.split(",")[0]
        });

    }

    const fetchConfig = async (path) => {
        let res = await axios.get(appendAccessToken(`${path}/config.json`));
        return res.data;
    }

    const fetchCatalog = async (path) => {
        let res = await axios.get(appendAccessToken(`${path}/catalog.json`));
        return res.data;
    }

    const fetchResources = async (path) => {
        let res = await axios.get(appendAccessToken(`${path}/resources.json`));
        return res.data;
    }

    const fetchTools = async (path) => {
        let res = await axios.get(appendAccessToken(`${path}/tools.json`));
        return res.data;
    }

    const reset = ()=> {
        console.log("reset @dataloader.js")
        bookData.annotations=[];
        bookData.catalog=[];
        bookData.config={};
        bookData.pagenames=[];
        bookData.resources={};
        bookData.tools=[];
    }


    return {
        bookData,
        fetchAll,
        reset
    }
}